import type { MembershipProduct } from "../../platform_spaces/space/SpaceType";
import { ProductSubscribeGate } from "../../products/subscribe_gate/ProductSubscribeGate";
import { StandaloneProductSubscribeCta } from "./StandaloneProductSubscribeCta";

type Props = {
  row: MembershipProduct;
};

/** 独立站产品页未开通：复用平台海报布局，订阅后续走独立站购买弹窗 */
export function StandaloneProductSubscribeGate(props: Props): JSX.Element {
  const { row } = props;
  return (
    <ProductSubscribeGate row={row}>
      <StandaloneProductSubscribeCta row={row} />
    </ProductSubscribeGate>
  );
}
